const pagePath = "/devices/loadmasters/:id";
export default pagePath;
